import styles from './Number.module.scss'

export default function Number({ active, callback }) {
  return (
    <div className={styles.containerStyle}>
      <svg
        style={{
          height: '24px',
          width: '24px',
          marginTop: '10px',
          marginRight: '5px',
        }}
        viewBox="0 0 24 24"
        onClick={() =>
          callback(
            parseInt(active, 10) !== 0
              ? parseInt(active, 10) - 1
              : parseInt(active, 10),
          )
        }
        className="decreaseButton"
      >
        <path fill="currentColor" d="M19,13H5V11H19V13Z" />
      </svg>
      <input
        type="text"
        min="0"
        max="9999"
        onChange={(e) => callback(e.target.value)}
        value={active}
        className={styles.guestInput}
      />
      <svg
        style={{ height: '24px', width: '24px', marginTop: '10px' }}
        viewBox="0 0 24 24"
        onClick={() => callback(parseInt(active, 10) + 1)}
        className="increaseButton"
      >
        <path
          fill="currentColor"
          d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
        />
      </svg>
    </div>
  )
}
